var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHearthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 79,
    viewBox: "0 0 93 79",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6507 65.5575C15.8652 55.244 7.03085 45.0926 2.99866 36.2583C-2.65451 23.7767 2.69472 8.90422 15.0952 3.17C18.4993 1.54902 22.0654 0.758789 25.6316 0.758789C33.1489 0.758789 41.4362 4.16285 46.3194 10.3631C53.5327 1.14377 66.9463 -1.81452 77.5638 3.14973C89.8832 8.88395 95.3135 23.7565 89.6603 36.238C85.6281 45.0723 76.7938 55.1427 64.0083 65.5372C55.9439 72.1225 48.5887 76.8436 46.3396 78.2417",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7524 38.8316H60.2363L51.8883 53.5015L40.5212 22.3179L32.0921 38.9127H21.8799",
    stroke: "#D70064",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearthIcon);
export default __webpack_public_path__ + "static/media/hearth-icon.46147d3d.svg";
export { ForwardRef as ReactComponent };